import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Params } from '@angular/router';
import { SessionService } from 'src/app/auth/session.service';
import ProjectLinks from 'src/app/common/project.links';
import { EntityStatus, ItemStatus } from 'src/app/interfaces/views.interface';
import { AccountStatus } from 'src/app/swagger-api';

@Component({
  selector: 'app-profile-link',
  templateUrl: './profile-link.component.html',
  styleUrls: ['./profile-link.component.scss'],
})
export class ProfileLinkComponent implements OnInit {
  public readonly DEFAULT_ROUTER_LINK: string = ProjectLinks.LINK_PROFILE_VIEW + '/';

  @Input({ required: true }) public status: EntityStatus;
  @Input({ required: true }) public userId: string;
  @Input({ required: true }) public text: string;
  @Input({ required: true }) public dataTestId: string;

  @Input({ required: false }) public cssStyles = '';
  @Input({ required: false }) public needComma = false;
  @Input({ required: false }) public disabledLink = false;
  @Input({ required: false }) public isHideStatus = false;
  @Input({ required: false }) public openInNewWindow = false;

  @Output() public submit: EventEmitter<void> = new EventEmitter<void>();

  public userUrl: string;
  public userUrlParams: Params;

  public get isActiveLink(): boolean {
    const isAdminSession = this.sessionService.isAdminSession();

    if (this.disabledLink) {
      return false;
    }

    if (this.status === AccountStatus.ACTIVE || this.status === ItemStatus.BLOCKED) {
      return true;
    }

    if (isAdminSession && this.status === AccountStatus.DEACTIVATED) {
      return true;
    }

    // For deleted accounts: no links
    return false;
  }

  private sessionService = inject(SessionService);

  public ngOnInit(): void {
    this.prepareUrl();
  }

  public prepareUrl(): void {
    if (this.sessionService.isSessionActive()) {
      this.userUrl = this.DEFAULT_ROUTER_LINK + this.userId;
    } else {
      this.userUrl = ProjectLinks.LINK_LOGIN;
      this.userUrlParams = { returnUrl: this.DEFAULT_ROUTER_LINK + this.userId };
    }
  }

  public onSubmit(): void {
    this.submit.emit();
  }
}
